import { Ng2StateDeclaration } from '@uirouter/angular';
import { FiDocumentTemplateEditComponent } from '@fi-app/document-template/document-template-edit/document-template-edit.component';
import { TemplateModel } from '@fi-app/template/template.model';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { Injector } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiDocumentTemplateCreateState: Ng2StateDeclaration = {
    name: FiStateNames.Document.Template.Add,
    url: '/Add',
    views: {
        '@': {
            component: FiDocumentTemplateEditComponent,
        },
    },
    resolve: {
        template: [Injector, FiDocumentTemplateCreateStateResolveTemplateResolveFunc],
        pageTitle: [PageTitleService, 'template', FiDocumentTemplateCreateStateResolvePageTitle],
    },
};

export function FiDocumentTemplateCreateStateResolveTemplateResolveFunc(injector: Injector) {
    return new TemplateModel(undefined, injector);
}

export function FiDocumentTemplateCreateStateResolvePageTitle(pageTitleService: PageTitleService, template) {
    return pageTitleService.setTitleByItem(template);
}
